import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { ProductInventoryTrackerComponent } from './product-inventory-tracker.component';


import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { SharedModule } from '../../shared.module';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SalonMonsterLoadMaskModule,
    SalonMonsterTapRetryModule,
    SharedModule,
    TableModule,
    DropdownModule,
  ],
  declarations: [ProductInventoryTrackerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductInventoryTrackerComponentModule {}
